import { createContext } from "react";

type AdminSideBarCtxType = {
  mobileOpen: boolean;
  openOnMobile: () => void;
  closeOnMobile: () => void;
  isCollapsed: boolean;
  toggleCollapsed: () => void;
};

const AdminSideBarCtx = createContext<AdminSideBarCtxType>({
  mobileOpen: false,
  openOnMobile: () => {
    throw new Error("openOnMobile not implemented");
  },
  closeOnMobile: () => {
    throw new Error("closeOnMobile not implemented");
  },
  isCollapsed: false,
  toggleCollapsed: () => {
    throw new Error("toggleCollapsed not implemented");
  },
});

export { AdminSideBarCtx };
